export var add = function (a, b) {
    return a + b;
};
// https://www.geeksforgeeks.org/closest-pair-of-points-using-divide-and-conquer-algorithm/
/**
 * Get the distance between the two given positions
 * @param p1
 * @param p2
 */
export var dist = function (p1, p2) {
    return Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) +
        (p1.y - p2.y) * (p1.y - p2.y));
};
/**
 * Get the average position of the two given positions
 * @param p1
 * @param p2
 */
export var average = function (p1, p2) {
    var x = (p1.x + p2.x) / 2;
    var y = (p1.y + p2.y) / 2;
    return { x: x, y: y };
};
export var string2Array = function (text) {
    var result = [];
    for (var c in text)
        result.push(c);
    return result;
};
export var printVertexArray = function (array) {
    var count = 0;
    for (var i = 0; i < array.length / 2; i++) {
        var start = i * 2;
        var end = start + 1;
        console.log(count++, 'x', array[start], 'y', array[end]);
    }
};
